import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "flaneriet-read-articles";

function getReadIds(): Set<string> {
  if (typeof window === "undefined") return new Set();
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

export function useReadArticles() {
  const [readIds, setReadIds] = useState<Set<string>>(() => getReadIds());

  useEffect(() => {
    setReadIds(getReadIds());
  }, []);

  const markRead = useCallback((id: string) => {
    if (typeof window === "undefined") return;
    const next = new Set(getReadIds());
    next.add(id);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...next]));
    setReadIds(next);
  }, []);

  const isRead = useCallback((id: string) => readIds.has(id), [readIds]);

  return { readIds, markRead, isRead };
}
